import axiosInstance from "../config/AxiosConfig";

export const shippingRepository = {
  getShippingFee: async () => {
    return await axiosInstance.get("/shipping/");
  },
  updateShippingFee: async (data) => {
    return await axiosInstance.post("/shipping", data);
  },
};
